import { CircleHelp } from "lucide-react";
import { helpUrl } from "../config";

/** A "?" that opens a Help Centre article (apps/help) in a new tab. `className` replaces the default icon button. */
export function HelpLink({ article = "", label, className, size = 16 }: { article?: string; label: string; className?: string; size?: number }) {
  return (
    <a className={className ?? "icon-btn"} href={helpUrl(article)} target="_blank" rel="noopener noreferrer" title={label} aria-label={label}>
      <CircleHelp size={size} />
    </a>
  );
}
